<template>
    <div class="search search-main">
        <div class="container">
            <div class="search__form">
                <div class="flex v-center search__form-wrap">
                    <input class="search__input"
                           type="text"
                           :name="result?.ajax?.searchName"
                           value=""
                           :placeholder="result.messages.placeholder"
                           @input="handlerInput($event)"
                           @click="handleOpen($event)"
                    >

                    <ABtn class="search__btn secondary" @click="getSearchElements">
                        <template #content>{{ result.messages.btnName }}</template>
                        <template #after>
                            <svg class="icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15.0505 14.5703L11.4651 10.6094C12.3547 9.48321 12.8559 8.06834 12.886 6.59859C12.9161 5.12884 12.4731 3.69219 11.6304 2.52601C10.7877 1.35984 9.59557 0.533944 8.25111 0.184796C6.90664 -0.164353 5.49026 -0.0158568 4.236 0.605745C2.98175 1.22735 1.96468 2.28485 1.35287 3.60352C0.741063 4.92219 0.571121 6.4231 0.871129 7.85824C1.17114 9.29339 1.92314 10.5769 3.00288 11.4966C4.08261 12.4164 5.42546 12.9173 6.80953 12.9167C8.05713 12.92 9.27486 12.5114 10.2942 11.7473L13.907 15.7415C13.9792 15.8213 14.0655 15.8851 14.161 15.9294C14.2564 15.9738 14.3592 15.9977 14.4633 15.9998C14.5675 16.002 14.671 15.9823 14.768 15.942C14.865 15.9016 14.9536 15.8414 15.0287 15.7647C15.1037 15.688 15.1639 15.5963 15.2056 15.4949C15.2473 15.3936 15.2698 15.2844 15.2719 15.1738C15.2739 15.0632 15.2554 14.9532 15.2174 14.8502C15.1794 14.7471 15.1227 14.6531 15.0505 14.5733V14.5703ZM6.80897 1.6804C7.69822 1.6804 8.5675 1.96048 9.30689 2.48523C10.0463 3.00997 10.6226 3.75582 10.9629 4.62844C11.3032 5.50106 11.3922 6.46127 11.2187 7.38764C11.0452 8.31401 10.617 9.16494 9.98821 9.83281C9.35942 10.5007 8.55828 10.9555 7.68612 11.1398C6.81396 11.3241 5.90994 11.2295 5.08838 10.868C4.26682 10.5066 3.56462 9.89448 3.07058 9.10914C2.57654 8.3238 2.31284 7.40049 2.31284 6.45597C2.31417 5.18985 2.7883 3.97598 3.6312 3.08069C4.4741 2.18541 5.61693 1.68181 6.80897 1.6804Z"
                                    fill="#E2E2E2"/>
                            </svg>
                        </template>
                    </ABtn>
                </div>
            </div>
            <div class="search__help">{{ result.messages.exampleText }}</div>
        </div>
        <transition
            name="fade"
        >
            <div
                v-if="openItems && value && Object.keys(response).length"
                class="container search__response"
            >
                <div class="search__elements">
                    <SearchEngineTopResponse :result="response" v-if="isResponseHasItemsToShow"/>
                    <div class="no-results" v-else>{{ result.messages.placeholderEmptyResults }}</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {ABtn} from '../ui';
import SearchEngineTopResponse from "./SearchEngineTop/SearchEngineTopResponse";

export default {
    name: 'SearchForm',
    props: ['result'],
    components: {
        SearchEngineTopResponse,
        ABtn,

    },
    setup: (props, ctx) => {

        return {}
    },
    data() {
        return {
            response: {},
            value: '',
            timeout: '',
            openItems: false,
            inputAnimationStep: 0,
            headerHeight: 0,
        };
    },
    methods: {
        handlerInput(e) {
            const result = this.result;
            let delay = 1000;
            if (result && result.ajax && result.ajax.searchName) {
                delay = result.ajax.searchName;
            }
            this.value = e.target.value;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(this.getSearchElements.bind(this), delay);
        },
        async getSearchElements() {
            try {
                const result = this.result;

                if (result && result.ajax && result.ajax.url && result.ajax.searchName && this.value !== '') {
                    let data = result.ajax.data;
                    data[result.ajax.searchName] = this.value;
                    const response = await axios.get(result.ajax.url, {params: data});
                    this.response = response.data || {};
                    this.openItems = true;
                } else {
                    this.response = {}
                }
            } catch (err) {
                console.error(err);
            }
        },
        handleOpen() {
            if (this.value === '') this.response = {};
            this.openItems = !this.openItems;

            if (this.openItems) {
                document.addEventListener('click', this.handlerAnotherClick, true);
            } else {
                document.removeEventListener('click', this.handlerAnotherClick, true);
                this.response = {}
            }
        },
        handlerAnotherClick({target}) {
            const parent = target.closest('.search__form');
            if (!parent) {
                this.openItems = false;
                document.removeEventListener('click', this.handlerAnotherClick);
            }
        },
    },
    computed: {
        isResponseHasItemsToShow() {
            let show = false;
            const checkKeys = ['tasks', 'npo', 'users', 'areas', 'blog']
            checkKeys.forEach(key => {
                if (this.response[key]?.length)
                    show = true;
            })

            return show
        },
    }
}
</script>

<style lang="scss">
.search {
    &__form-wrap {
        background: #fff;
        border-radius: var(--br-1);
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
        padding: 5px;
        align-items: stretch;

        @include tablet {
            padding: 3px;
        }
    }

    &__input {
        background: #fff;
        flex: 1000 0 0;
        border: none;
        height: 50px;
        font-size: 16px;
        display: block;
        padding: 0 19px;

        @include tablet {
            height: 40px;
            font-size: 14px;
            padding: 0 10px;
        }

        &::placeholder {
            color: var(--c-gray-400);
        }
    }

    &__btn {
        width: 163px;
        height: auto;
        background: var(--c-secondary-200);
        @include tablet {
            width: 144px;
        }
        @include mobile {
            width: 40px;
            height: auto;
            max-height: unset;
            padding: 0;
        }

        .a-btn {
            &-after {
                display: none;
                @include mobile {
                    display: inline-flex;
                    margin: 0;
                }
            }

            &-title {
                @include mobile {
                    display: none;
                }
            }
        }
    }

    &__help {
        font-size: 14px;
        line-height: 20px;
        color: var(--c-gray-400);
        margin-top: 16px;

        @include tablet {
            font-size: 12px;
            margin-top: 8px;
        }
        @include mobile {
            display: none;
        }
    }

    &__response {
        position: absolute;
        //top: 100%;
        top: calc(100% - 35px);
        left: 0;
        right: 0;
        z-index: 2;
        background-color: #fff;
        color: var(--text-colour-primary);
        //border: 1px solid #CACECE;

        @include mobile {
            top: 100%;
        }
    }

    &__elements {
        padding: 16px;
        background: #F6F6F6;
        max-height: 388px;
        height: max-content;
        overflow: auto;
    }

    &__input {
        width: 100%;
        padding: 5px 10px;
        margin: 5px 8px 5px 0;
        border: none;
        font-weight: 500;
        font-size: rem(16);
        line-height: 100%;
    }
}

.search-home {
    .search-main {
        margin-top: -30px;
        z-index: 10;
        position: relative;
        margin-bottom: 40px;
        @include tablet {
            margin-top: -22px;
            margin-bottom: 30px;
        }
        @include mobile {
            margin-top: 28px;
            margin-bottom: 30px;
        }
    }
}
</style>
